module.exports = __webpack_public_path__ + "static/media/sistema-manutencoes-plano-starter.0e274fbf.png";